import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { PROJECT_MANAGEMENT_URL } from '@insite-store360/shared';

@Injectable({
    providedIn: 'root'
})
export class LostReasonService {
    private readonly URL_PATH = `${PROJECT_MANAGEMENT_URL}/lost-reason`;

    constructor(
        private http: HttpClient,
        // private commonService: CommonService // Not needed for URL
    ) { }

    getLostReasonByCountryId(countryId?: number, countryIds?: number[]): Observable<any> {
        let params = new HttpParams();
        if (countryId) {
            params = params.append('countryId', countryId.toString());
        }
        if (countryIds && countryIds.length > 0) {
            countryIds.forEach(id => {
                params = params.append('countryIds', id.toString());
            });
        }
        return this.http.get(this.URL_PATH + '/getLostReasonByCountryId', { params });
    }

    getAll(pageIndex?: number, pageSize?: number, searchValue?: string, countryId?: number): Observable<any> {
        let params = new HttpParams();
        if (pageIndex) params = params.append('pageIndex', pageIndex.toString());
        if (pageSize) params = params.append('pageSize', pageSize.toString());
        if (searchValue) params = params.append('searchValue', searchValue);
        if (countryId) params = params.append('countryId', countryId.toString());

        return this.http.get(this.URL_PATH + '/getAll', { params });
    }

    create(data: { reason: string; countryId: number }): Observable<any> {
        return this.http.post(this.URL_PATH + '/create', data);
    }

    update(id: number, data: { reason: string; countryId: number }): Observable<any> {
        return this.http.put(this.URL_PATH + `/update/${id}`, data);
    }

    delete(id: number): Observable<any> {
        return this.http.delete(this.URL_PATH + `/delete/${id}`);
    }
}
